export default {
  hint: "Record counts from the live NBR catalogue.",
  relation: "Relations",
  total: "Total records",
  updated: "Updated {{date}}",
  countsTitle: "NBR catalogue records",
  byYear: "Editions by year",
  topPublishers: "Publishers",
  topSubjects: "Subjects",
  topPrizes: "Prizes",
  empty: "No statistics collected yet.",
}
